import { useLanguage } from "../i18n/LanguageProvider";
import type { Locale } from "../i18n/messages";
import { logout } from "../lib/auth";

export function LanguageToggle() {
  const { locale, setLocale } = useLanguage();
  const options: Locale[] = ["th", "en"];
  return (
    <div role="group" aria-label="Language" style={{ display: "inline-flex", gap: 4 }}>
      {options.map((l) => (
        <button
          key={l}
          className="btn btn--secondary"
          style={{ minHeight: 36, padding: "0 12px" }}
          aria-pressed={locale === l}
          onClick={() => setLocale(l)}
        >
          {l.toUpperCase()}
        </button>
      ))}
    </div>
  );
}

export function AppHeader() {
  const { t } = useLanguage();
  return (
    <header className="app-header">
      <strong>{t("appName")}</strong>
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <LanguageToggle />
        <button className="btn btn--secondary" style={{ minHeight: 36 }} onClick={logout}>
          {t("signOut")}
        </button>
      </div>
    </header>
  );
}
